import React from "react";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { generateDocumentReport } from "../../../../actions/actionCreators/offer/offerActions";
import PropTypes from "prop-types";
import OfferReportsListComponent from "./OfferReportsListComponent";

export const OfferReportsContainer = ({ documentId, siteId, reports, actions, onHandleShowReportsModal }) => {
  const closeReportsModal = () => {
    onHandleShowReportsModal(false);
  };

  const downloadReport = report => () => {
    let reportWithParams = Object.assign({}, report, { documentId: documentId, siteId: siteId });
    actions.generateDocumentReport(reportWithParams);
  };

  return (
    <OfferReportsListComponent
      reports={reports}
      onCloseReportsModal={closeReportsModal}
      onReportDownload={downloadReport}
    />
  );
};

OfferReportsContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  reports: PropTypes.array,
  actions: PropTypes.object.isRequired,
  onHandleShowReportsModal: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    reports: state.currentOffer.offerReports
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ generateDocumentReport }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(OfferReportsContainer);
